/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconDeliver = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 34 34"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 34px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        transform="translate(1 1)"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M20.8 21.599l-4.8-4.8-4.8 4.8"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M8 28.828H2.667c-1.472 0-2.667-1.075-2.667-2.4V2.4C0 1.075 1.195 0 2.667 0h26.666C30.805 0 32 1.075 32 2.4v24.028c0 1.325-1.195 2.4-2.667 2.4H24"
        />
        <rect
          width={1.2}
          height={1.2}
          x={3}
          y={3.8}
          fill="currentColor"
          fillRule="nonzero"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          rx={0.338}
        />
        <rect
          width={1.2}
          height={1.2}
          x={7}
          y={3.8}
          fill="currentColor"
          fillRule="nonzero"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          rx={0.338}
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M16 32V16.828"
        />
        <path
          strokeLinecap="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M4 9.2h24"
        />
        <rect
          width={1.2}
          height={1.2}
          x={11.4}
          y={3.8}
          fill="currentColor"
          fillRule="nonzero"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          rx={0.338}
        />
      </g>
    </svg>
  ),
);
